type Translator = (key: string, options?: { defaultValue?: string }) => string;

/** Spanish literals persisted in DB / API (must match elsa-api seeds and elsa-platform). */
export const CANONICAL_JOB_WITH_STAFF = "Puesto con personal a cargo";
export const CANONICAL_JOB_WITHOUT_STAFF = "Puesto sin personal a cargo";

const canonicalJobKeyMap: Record<string, string> = {
  [CANONICAL_JOB_WITH_STAFF]: "jobPosition.canonical.withStaff",
  [CANONICAL_JOB_WITHOUT_STAFF]: "jobPosition.canonical.withoutStaff",
};

/**
 * Maps stored Spanish canonical job labels to the active i18n language for display.
 * Custom organization-defined descriptions are returned unchanged.
 */
export function translateCanonicalJobDescription(
  description: string,
  t: Translator
): string {
  const i18nKey = canonicalJobKeyMap[description];
  if (!i18nKey) return description;
  return t(i18nKey, { defaultValue: description });
}
